export default __webpack_public_path__ + "static/media/Accounting.ded3ea90.png";